module.exports = __webpack_public_path__ + "494cd07c/img/grid-web-icon.d0395d64.svg";